<div class="card desktop-card border-0 shadow-sm" *ngIf="!isMobile">
    <div class="card-body p-0">
        <div class="card-body-header">
            <div class="tag-wrapper" *ngIf="isLastPlan">
                <span>RECOMMENDED</span>
            </div>
        </div>
        <div class="card-body-content" [ngStyle]="{ 'margin-top': !isLastPlan ? '25px' : '0px' }">
            <div class="emi-price-content">
                <div class="price-wrpper">
                    <h2>&#8377; {{ formatValRound(plan.emi_amount) }}</h2>
                    <p class="timmings">/ month </p>
                </div>
                <div class="subscription-plan-wrapper" (click)="selectPlan(plan)">
                    {{ plan.tenor }} months <i class="fas fa-angle-right"></i>
                </div>
            </div>
            <div class="card-footer px-0 py-3">
                <div class="notes">
                    <div>
                        <p>Loan</p>
                        <p class="value">&#8377; {{ formatValRound(plan.loan_amount) }}</p>
                    </div>
                    <div>
                        <p>Interest</p>
                        <p class="value">&#8377; {{ generatedInterest }}</p>
                    </div>
                    <div>
                        <p>Processing fee</p>
                        <p class="value">&#8377; {{ generatedProcessingFee }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="card mobile-card" *ngIf="isMobile">
    <div class="card-body">
        <div class="d-flex align-items-center justify-content-between">
            <div class="check-icon">
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="emiPlan" [id]="'emiPlanfor-' + plan.tenor"
                        (change)="selectPlan(plan)" [checked]="isLastPlan">
                    <label class="form-check-label" [for]="'emiPlanfor-' + plan.tenor">
                        <h3>{{ plan.tenor }} months</h3>
                    </label>
                </div>
            </div>

            <div class="price-for-installment d-flex align-items-center gap-2">
                <p>&#8377; {{ plan.emi_amount }}</p>

                <span class="expand-icons" [ngClass]="{'active': plan.isCollapsed}"
                    (click)="plan.isCollapsed = !plan.isCollapsed">
                    <i class="fas fa-angle-right"></i>
                </span>
            </div>
        </div>

        <div *ngIf="!plan.isCollapsed" class="expanded-contents" [@collapse]>
            <h3 class="expanded-contents-title mt-2">Plan description</h3>
            <ul class="pl-0 m-0">
                <li>
                    <p class="m-0">Loan - <span>&#8377; {{ formatValRound(plan.loan_amount) }}</span></p>
                </li>
                <li>
                    <p class="m-0">Interest- <span>&#8377; {{ generatedInterest }}</span></p>
                </li>
                <li>
                    <p class="m-0">Processing Fee - <span>&#8377; {{ generatedProcessingFee }}</span></p>
                </li>
            </ul>
        </div>
    </div>
</div>